import i18next from 'i18next';

class ConsoleUI {

    public autoscroll: boolean = true;
    protected connected: boolean = false;
    protected filters: Function[] = [];

    public constructor(protected $base: JQuery) {}

    public setFilters(filters: Function[])  {
        this.filters = filters;
    }

    public onSubmit(callback: (input: string) => void): void {
        this.$base.find('#rconCommand').on('keyup', (event) => {
            if (event.which === 13 && event.shiftKey === false) {
                if (true === this.connected) {
                    callback(this.$base.find('#rconCommand').val() as string);
                }
            }
        });

        this.$base.find('#sendRconCommand').on('click', () => {
            callback(this.$base.find('#rconCommand').val() as string);
        });
    }

    public clearInput(): void {
        this.$base.find('#rconCommand').val('');
    }

    public setConnectionStatus(value: boolean): void {
        this.connected = value;

        let button = document.getElementById('sendRconCommand');

        if (this.connected) {
            button.removeAttribute('disabled')
        } else {
            button.setAttribute('disabled', '');
        }
    }

    public writeToConsole(data: string, clazz = 'row-standard'): void {
        // Strip ANSI escape characters
        data = data.replace(/[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, '');

        // Apply filters (e.g. JSON decoding)
        this.filters.forEach((filter) => {
            data = filter(data);
        })

        // Create div for the message
        const messageDiv = $("<div></div>").addClass(clazz);
        // Split lines
        const lines = data.split('\n');
        // Iterate over lines w/ index
        for (const [i, line] of lines.entries()) {
          // Add a span with and add the text to it using the text function, implicitly escaping the
          // string
          messageDiv.append($("<span></span>").text(line));
          // If we are not on the last line, also add a break tag
          if (i !== lines.length-1) {
            messageDiv.append("<br/>")
          }
        }
        // Add the message div to the console history
        this.$base.find('.console-output').append(messageDiv);
        if (this.autoscroll === true) {
            const con = document.getElementById('console');
            con.scrollTop = con.scrollHeight;
        }
    }

    public onAutoscrollChange(): void {
        let checkboxIndex = this.$base.find('.fancy-checkbox input').data('index');
        window.checkboxes[checkboxIndex].onChange = () => {
            this.autoscroll = this.autoscroll === false;
        };
    }
}

export default ConsoleUI;
